import {UPDATE_TAB_VALUE} from './types'

export const updateTabValue = (tabValue) => async (dispatch) => {
    await dispatch({
        type: UPDATE_TAB_VALUE,
        payload: tabValue
    });
};